import React from "react";
import { Outlet } from "react-router-dom";
import { Toaster } from "react-hot-toast";

// Thin layout wrapper for the academy feature.
// Provides react-hot-toast's Toaster so all CRUD pages share one notification layer.
function AcademyLayout() {
  return (
    <>
      <Toaster position="top-right" toastOptions={{ duration: 3500 }} />
      <Outlet />
    </>
  );
}

export { AcademyLayout };
